import { RootState } from 'shared/redux/store'
import { ViewMode } from '../../../BookingCalendarController/model'
import moment from 'moment/moment'
import { setUTCTimezone } from 'shared/utils/timezone'

export const selectBookings = (state: RootState) =>
    state.bookingSidebarForm.bookings

export const selectActiveBookingId = (state: RootState) =>
    state.bookingSidebarForm.activeBookingId

export const selectBookingIdToEdit = (state: RootState) =>
    state.bookingSidebarForm.bookingIdToEdit

export const selectBookingCurrentStep = (state: RootState) =>
    state.bookingSidebarForm.currentStep

export const selectBookingMode = (state: RootState) =>
    state.bookingSidebarForm.mode

export const selectBookingCounterparty = (state: RootState) =>
    state.bookingSidebarForm.counterparty

export const selectBookingOrderId = (state: RootState) =>
    state.bookingSidebarForm.orderId

export const selectBookingFormMode = (state: RootState) =>
    state.bookingSidebarForm.mode

export const selectBookingFormOrderViewMode = (state: RootState) =>
    state.bookingSidebarForm.orderViewMode

export const selectBookingOriginalOrder = (state: RootState) =>
    state.bookingSidebarForm.originalOrder

export const selectActiveBookingFormTab = (state: RootState) =>
    state.bookingSidebarForm.bookingActiveTab

export const selectOrderEditStateInitialising = (state: RootState) =>
    state.bookingSidebarForm.isEditStateInitialising

export const selectOrderTotalPrice = (state: RootState) =>
    state.bookingSidebarForm.totalPrice

export const selectToday = (state: RootState) => state.bookingSidebarForm.today

export const selectView = (state: RootState) => state.bookingSidebarForm.view

export const selectTimeFilter = (state: RootState) => {
    const today = moment(state.bookingSidebarForm.today)
    const view = state.bookingSidebarForm.view

    if (view === ViewMode.Day) {
        const startMonthTime = setUTCTimezone(today.startOf('month').toDate())

        return {
            startTime: startMonthTime,
        }
    }
    if (view === ViewMode.Week) {
        const startMonthTime = setUTCTimezone(today.startOf('month').toDate())

        return {
            startTime: startMonthTime,
        }
    }
    if (view === ViewMode.Month) {
        const startMonthTime = setUTCTimezone(today.startOf('month').toDate())

        return {
            startTime: startMonthTime,
        }
    }
    return
}

export const selectIsDirtyBookingForm = (state: RootState) =>
    state.bookingSidebarForm.isDirty

export const selectIsCompanyBookingForm = (state: RootState) =>
    state.bookingSidebarForm.isCompany

export const selectCurrentCalendarEvents = (state: RootState) =>
    state.bookingSidebarForm.currentCalendarEvents

export const selectExpireIn = (state: RootState) =>
    state.bookingSidebarForm.expireIn

export const selectIsHistoryModeEnabled = (state: RootState) =>
    state.bookingSidebarForm.isHistoryModeEnabled

export const selectIsRedirectForCounterpartyCreation = (state: RootState) =>
    state.bookingSidebarForm.isRedirectForCounterpartyCreation

export const selectContactId = (state: RootState) =>
    state.bookingSidebarForm.contactId
